import React from 'react';
import {Separator} from '../components/ui/separator';
import {Text} from '../components/ui/text';

import {useIsAdmin} from '../state/hooks';
import {ManageDevices} from './ManageDevices';
import {ManageStaff} from './ManageStaff';

/**
 * General settings page.
 */
export const Settings = () => {
  const isAdmin = useIsAdmin();

  return (
    <div className="max-w-4xl p-8 mx-auto">
      {/* My Devices Section */}
      <section>
        <h2 className="text-2xl font-semibold text-secondary mb-4">
          My Devices
        </h2>
        <div className="space-y-6">
          <div className="space-y-4">
            <p className="text-color-(--foreground) leading-relaxed">
              This is a list of devices you have logged into Nudge with. If you
              have logged in on multiple browser sessions, or cleared your
              browser's storage at any time, you may see multiple entries here.
            </p>
            <p className="text-color-(--foreground) leading-relaxed">
              Generally you don't have to worry about the values here.
            </p>
          </div>
          <ManageDevices />
        </div>
      </section>

      {isAdmin && (
        <>
          <Separator className="my-8" />

          {/* Users Section */}
          <section>
            <h2 className="text-2xl font-semibold text-secondary mb-4">
              Users
            </h2>
            <div className="space-y-6">
              <div className="space-y-4">
                <Text className="text-color-(--foreground) leading-relaxed">
                  This is a list of all staff members we know about in your
                  organization. You can use this table to manage their access to
                  Nudge.
                </Text>

                <ul className="space-y-3 text-color-(--foreground) mx-8">
                  <li className="flex items-start">
                    <span className="text-blue-600 font-medium mr-2">•</span>
                    <span>
                      Turn on the <strong>Admin</strong> toggle for users who
                      should have access to administrative features, such as
                      this table.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 font-medium mr-2">•</span>
                    <span>
                      Turn on the <strong>Staff</strong> toggle for users who
                      should have access to Nudge.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 font-medium mr-2">•</span>
                    <span>
                      Turn off the <strong>Active</strong> toggle to disable
                      access to Nudge entirely for a user.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 font-medium mr-2">•</span>
                    <span>
                      You can use the search box above the table to find
                      specific users.
                    </span>
                  </li>
                </ul>
              </div>
              <ManageStaff />
            </div>
          </section>
        </>
      )}
    </div>
  );
};
